import { Injectable, inject } from '@angular/core';
import { CanDeactivateFn } from '@angular/router';

/** #926 - the open bulk wizard, when it holds data, registers here so leaving the page (a route change) asks first; the wizard's own beforeunload covers closing the tab. */
@Injectable({ providedIn: 'root' })
export class BulkWizardLeaveService {
  /** Set by the wizard while it holds data; resolves true when the person agrees to lose it. */
  check: (() => Promise<boolean>) | null = null;

  confirmLeave(): boolean | Promise<boolean> {
    return this.check ? this.check() : true;
  }
}

export const bulkWizardLeaveGuard: CanDeactivateFn<unknown> = () => inject(BulkWizardLeaveService).confirmLeave();
